(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wm-offer-progress"] && !Shopify.designMode) return;
  try {
    (() => {
  const previous = new Map();
  let pending = false;
  const refresh = () => {
    pending = false;
    const panels = [...document.querySelectorAll('.wm-offer[data-eligible-quantity]')];
    if (!panels.length) previous.clear();
    panels.forEach(panel => {
      const key = panel.closest('[id^="shopify-section"]')?.id || 'drawer';
      const quantity = Number(panel.dataset.eligibleQuantity);
      const before = previous.get(key) ?? 0;
      previous.set(key, quantity);
      if (quantity <= before || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const start = Math.min(before, 2);
      const end = Math.min(quantity, 3);
      const icons = panel.querySelectorAll('.wm-offer__step');
      for (let index = start; index < end; index++) {
        const icon = icons[index];
        if (!icon) continue;
        icon.getAnimations().forEach(animation => animation.cancel());
        const play = () => icon.animate([
          { transform: 'scale(.85)', backgroundColor: '#fff', color: '#541d23', boxShadow: '0 0 0 0 rgba(84,29,35,.28)' },
          { transform: 'scale(1.15)', backgroundColor: '#541d23', color: '#fff', boxShadow: '0 0 0 9px rgba(84,29,35,.10)', offset: .55 },
          { transform: 'scale(1)', backgroundColor: '#541d23', color: '#fff', boxShadow: '0 0 0 14px rgba(84,29,35,0)' }
        ], { duration: 750, delay: (index - start) * 130, easing: 'ease-out' });
        const visible = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            visible.disconnect();
            if (icon.isConnected && icon.classList.contains('is-complete')) play();
          }
        }, { threshold: .7 });
        visible.observe(icon);
        setTimeout(() => visible.disconnect(), 30000);
      }
    });
  };
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(refresh); } };
  refresh();
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-eligible-quantity'] });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wm-product-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wm-delivery-estimate')) {
    customElements.define('wm-delivery-estimate', class extends HTMLElement {
      connectedCallback() {
        const base = new Date();
        const addDays = (count) => {
          const date = new Date(base);
          while (count > 0) { date.setDate(date.getDate() + 1); if (date.getDay() !== 0 && date.getDay() !== 6) count--; }
          return date;
        };
        const format = new Intl.DateTimeFormat(this.dataset.locale || 'en', {day:'numeric',month:'short'});
        this.querySelector('[data-wm-delivery-range]').textContent = `${format.format(addDays(2))} – ${format.format(addDays(4))}`;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
